import React, { createContext, useContext, useReducer } from "react";

// Initialize Context
const StatsContext = createContext();

// Reducer function to update the stats state
const statsReducer = (state, action) => {
  switch (action.type) {
    case "SET_STATS":
      return {
        ...state,
        stats: action.payload,
        loading: false,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

// Initial state
const initialState = {
  stats: {
    pending_users: 0,
    registered_users: 0,
    available_products: 0,
    total_products: 0,
  },
  loading: true,
};

// Context provider component
export const StatsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(statsReducer, initialState);

  return (
    <StatsContext.Provider value={{ state, dispatch }}>
      {children}
    </StatsContext.Provider>
  );
};

// Custom hook to use stats context
export const useStats = () => {
  return useContext(StatsContext);
};
